import { useContext } from 'react';
import { RsiContext } from '../components/Providers';
import type { MarkRequired, RsiProps } from '../types';

import type { defaultRSIProps } from '../ReactSpreadsheetImport';
import { RsiTranslations } from '../translations/RsiTranslations.types';

export const useRsi = <T extends string>() =>
  useContext<MarkRequired<RsiProps<T>, keyof typeof defaultRSIProps> & { translations: RsiTranslations }>(RsiContext);
